import { Component } from '@angular/core';
import { nodeType } from 'src/app/core/constants/constants';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-scad-right-sidebar',
  templateUrl: './scad-right-sidebar.component.html',
  styleUrls: ['./scad-right-sidebar.component.scss']
})
export class ScadRightSidebarComponent {

  public lastSelectedNode!: HTMLElement;
  public lastSelectedNodeType!: string;
  private subs: SubSink = new SubSink();
  public nodeTypes: any = nodeType;


  constructor(public _flowBuilder: FlowBuilderService){
    this.subs.add(
      this._flowBuilder.nodeDoubleClick$.subscribe((res: string | any) => {
        this.onNodeDoubleClick(res.type, res.element);
      }
      ));
  }


  ngOnInit(): void {}


  onNodeDoubleClick(type: string, element: HTMLElement) {
    this._flowBuilder.clickFlag = -1;
    this.lastSelectedNode = element;
    this.lastSelectedNodeType = type;

  }


  onFileChange(env: any, type: string) {
    const activeNode = this._flowBuilder.activeNode;
    if (!activeNode.connection) {
      activeNode.connection = {};
    }
    let files: any[] = [];
    switch (type) {
      case 'drop':
        files = env;
        break;

      case 'click':
        files = env.files
        break;

      default:
        break;
    }
   
    

    let fileTypes = ['.xls', '.xlsx', 'application/pdf', '.pdf', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', '.csv', '.doc', '.docx', '.xml', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
   let invC = true
    for (let i = 0; i < files.length; i++) {
      const element = files[i];

      if (!fileTypes.includes(element.type)) {
        invC = false;
      }
    }
    if (!invC) {
      alert('Invalid doc');
      return;
    }

    activeNode.connection.file = files[0];
    activeNode.sourceFile = files[0]?.name;


  }

}
